import { errorFragment as GQLErrorFragment } from 'queries/__generated__/errorFragment';

export default function errorLogger(message: string) {
  return (error?: Error | GQLErrorFragment | string | object | undefined) => {
    const Rollbar = (<any>window).Rollbar || {};
    if (Rollbar && typeof Rollbar.error === 'function') {
      Rollbar.error(message, error);
    } else {
      console.warn(error);
      console.error(message);
    }
  };
}
